<button
  type="button"
  [ngClass]="{'btn btn-full-orange': true, 'clicked': clicked, 'btn-small': small }"
  (click)="onClick()"
  [disabled]="disabled">
  <label *ngIf="!clicked">{{ label }}</label>
  <label *ngIf="clicked">{{ afterLabel }}</label>
</button>
